import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogContent,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import styles from './MeasureOneImportDocumentsDialog.module.css'
import { links } from '@/utils/link'
import { type Id } from '@/infra/id'

const measureOneStepDetails = [
  {
    stepNumber: 1,
    stepText: 'Begin the secure connection flow',
  },
  {
    stepNumber: 2,
    stepText: "Use your existing provider's login",
  },
  {
    stepNumber: 3,
    stepText: 'Confirm and import documents',
  },
]

export interface MeasureOneImportDocumentsDialogProps {
  jobId: Id
  isOpen: boolean
  onClose: () => void
}

export function MeasureOneImportDocumentsDialog({
  jobId,
  isOpen,
  onClose,
}: MeasureOneImportDocumentsDialogProps) {
  return (
    <ModalDialog isOpen={isOpen}>
      <ModalDialogHeader textAlign="center">
        <ModalDialogTitle testId="tax-info-gathering-measure-one-import-docs-dialog">
          Import your documents automatically
        </ModalDialogTitle>
        <ModalDialogDescription>
          Sign in to the accounts that hold your tax documents. MeasureOne will
          securely pull the files for you.
        </ModalDialogDescription>
      </ModalDialogHeader>

      <ModalDialogContent>
        <div className={styles.content}>
          <div className={styles.title}>How it works</div>

          <div className={styles.steps}>
            {measureOneStepDetails.map(({ stepNumber, stepText }) => (
              <MeasureOneStepDetail
                stepNumber={stepNumber}
                stepText={stepText}
                key={stepNumber}
              />
            ))}
          </div>
        </div>
      </ModalDialogContent>

      <ModalDialogFooter>
        <ModalDialogActions>
          <Button
            label="Start connection"
            variant="default"
            to={links.measureOneSelectExperienceType(jobId)}
          />
          <Button
            testId="measure-one-import-documents-dialog-skip-button"
            label="No thanks, I'll do it manually"
            variant="outline"
            onPress={onClose}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}

interface MeasureOneStepDetailProps {
  stepNumber: number
  stepText: string
}

function MeasureOneStepDetail({
  stepNumber,
  stepText,
}: MeasureOneStepDetailProps) {
  return (
    <div key={stepNumber}>
      <div className={styles.stepNumber}>{stepNumber}</div>

      <div className={styles.stepText}>{stepText}</div>
    </div>
  )
}
